export const Contact00DataSource = {
    wrapper: {className: 'home-page-wrapper content10-wrapper'},
    page: {className: 'contact-page'},
    Content: {
        className: 'icon-wrapper',
        children: {
            icon: {
                className: 'icon',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
                name: '主要图标',
            },
            iconShadow: {
                className: 'icon-shadow',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
                name: '图标影阴',
            },
            // url: { children: 'https://gaode.com/place/B00155Q7EO', name: '跳转地址' },
            url: {
                children: 'https://gaode.com/search?query=%E4%B8%B4%E6%B8%AF%E8%8E%98%E6%B5%B7%E7%A7%91%E6%8A%80%E5%9B%AD1%E5%8F%B7%E6%A5%BC',
                name: '跳转地址'
            },
            title: {children: '公司地址', name: '弹框标题'},
            content: {
                children: '闵行区七莘路1189号临港莘海科技园1号楼10楼1005~1006室',
                name: '弹框内容',
            },
        },
    },
};

export const FormDataSource = {

    options: {
        job: [
            {
                val: '0',
                text: '工程师'
            },
            {
                val: '1',
                text: '销售经理'
            },
            {
                val: '2',
                text: '产品经理'
            },
            {
                val: '3',
                text: '技术经理'
            },
            {
                val: '4',
                text: '项目经理'
            }
        ],
        prod: [
            {
                val: '0',
                text: '医疗供应链 - UDI码追溯',
            },
            {
                val: '1',
                text: '医疗供应链 - 骨科内固定器械清点',
            },
            {
                val: '2',
                text: '医疗供应链 - 手术工具清点',
            },
            {
                val: '3',
                text: '数据治理 - 器械主数据对码',
            },
            {
                val: '4',
                text: '数据治理 - 首营资料智能管理'
            },
            {
                val: '5',
                text: '数据治理 - AI标书自动写作平台'
            },
            {
                val: '6',
                text: '数据治理 - 企业智能问答系统'
            },
            {
                val: '7',
                text: '工业质检 - 口红质检'
            },
            {
                val: '8',
                text: '工业质检 - 瓶底喷码质检'
            },
            {
                val: '9',
                text: '新能源 - 太阳能板质检'
            }
        ],
        companyType: [
            {
                val: '0',
                text: '终端用户'
            },
            {
                val: '1',
                text: '硬件制造商'
            },
            {
                val: '2',
                text: '集成商'
            },
            {
                val: '3',
                text: '其他'
            }
        ],
        trade: [
            {
                val: '0',
                text: '新能源'
            },
            {
                val: '1',
                text: '彩妆'
            },
            {
                val: '2',
                text: '医疗'
            },
            {
                val: '3',
                text: '工业制造'
            },
            {
                val: '4',
                text: '其他'
            }
        ]
    },
}
